<template>
  <section
    class="error-pid-limit__wrapper"
  >
    <div>
      <h2 class="error-pid-limit__title">
        Não foi possível processar o volume de dados do gráfico
      </h2>
      <p class="error-pid-limit__description">
        Selecione um intervalo de data menor e tente novamente.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ErrorPidLimit',
};
</script>

<style lang="scss" scoped>
.error-pid-limit {
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 330px;
  }

  &__title {
    text-align: center;
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-baseline);
    margin-bottom: var(--ds-spacing-stack-nano);
  }

  &__description {
    text-align: center;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-color-text-2);
    margin-bottom: var(--ds-spacing-stack-xs);
  }
}
</style>
